const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/folding-machines`,
    saveSpeedTable: `${API_URL}/folding-machine/save-speed-table`,
    saveMakeReadyTable: `${API_URL}/folding-machine/save-make-ready-table`,
};

export default apiUrls;
